import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import 'assets/scss/components/locationModal.css';

const AddCardSuccessModal = ({
  isVisible,
  toggleSuccessModal,
  businessName,
  fetchBusinessDetail,
  modalContent,
}) => {
  const onToggle = () => {
    toggleSuccessModal();
    fetchBusinessDetail();
  };

  const renderContent =
    modalContent.type === 'charge' ? (
      <p className="text-center">
        <strong>
          You have charged {businessName} ${modalContent.amount}.
        </strong>
        <br />
        This charge will appear in the Billing Activity section of their
        account.
      </p>
    ) : (
      <p className="text-center">
        Congratulation! you have successfully configured payment plan for{' '}
        <strong>{businessName}</strong>
      </p>
    );
  return (
    <Modal
      className="success-modal"
      isOpen={isVisible}
      toggle={onToggle}
      onClickBackdrop={onToggle}
    >
      <ModalBody className="p-5">
        <div className="icon-holder">
          <FontAwesomeIcon icon="check" />
        </div>
        <h5 className="text-center mb-4">Success</h5>
        {renderContent}
        <button
          type="button"
          className="btn-warning btn-md col-md-12 py-2 pl-3 pr-3 text-white text-bold border-0 mt-4 w-75 success-done-btn"
          onClick={onToggle}
        >
          Done
        </button>
      </ModalBody>
    </Modal>
  );
};

AddCardSuccessModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleSuccessModal: PropTypes.func.isRequired,
};

export default AddCardSuccessModal;



// WEBPACK FOOTER //
// ./src/components/Modal/creditCard/addCardSuccess.js